import careersConfig from "components/pages/careers/careers-config.json";
import * as Sentry from "@sentry/nextjs";
const LOCATIONS = {
    london: [
        "london"
    ],
    miami: [
        "miami"
    ],
    newyork: [
        "york"
    ],
    sf: [
        "sf",
        "san franc"
    ],
    sydney: [
        "sydney"
    ],
    telaviv: [
        "aviv"
    ],
    tokyo: [
        "tokyo",
        "japan"
    ],
    chicago: [
        "chicago"
    ],
    saopaulo: [
        "sao paulo"
    ],
    denver: [
        "denver"
    ],
    houston: [
        "houston"
    ],
    austin: [
        "austin"
    ],
    warsaw: [
        "warsaw",
        "warsha"
    ],
    singapore: [
        "singapore"
    ],
    melbourne: [
        "melbourne"
    ],
    paris: [
        "paris"
    ],
    munich: [
        "munich",
        "munchen"
    ],
    atlanta: [
        "atlanta"
    ],
    "remote-us": [
        "remoteus",
        "remote, us",
        "remote-us",
        "remote_us",
        "remote us",
        "us remote"
    ],
    "remote-latam": [
        "remotelatam",
        "remote, latam",
        "remote-latam",
        "remote_latam",
        "remote latam",
        "latam remote",
        "santiago remote",
        "buenos aires remote",
        "argentina remote"
    ],
    "remote-emea": [
        "zurich remote",
        "amsterdam remote",
        "remote-emea"
    ],
    mexicocity: [
        "mexico city"
    ],
    zurich: [
        "zurich"
    ],
    amsterdam: [
        "amsterdam"
    ],
    brazil: [
        "brazil",
        "brasil"
    ]
};
const DEPARTMENT_ALIASES = {
    events: "customersucc"
};
const DEPARTMENTS = {
    customersucc: [
        "client relations",
        "customer succ",
        "customer management",
        "empowerment & loyalty",
        "voice of costumer"
    ],
    marketing: [
        "marketing",
        "lifecycle & monetization"
    ],
    hr: [
        "hr",
        "people"
    ],
    rnd: [
        "r&d"
    ],
    design: [
        "design"
    ],
    product: [
        "product"
    ],
    finance: [
        "finance"
    ],
    consulting: [
        "consulting",
        "revenue growth"
    ],
    partnership: [
        "partnership"
    ],
    businessoperations: [
        "business operations"
    ],
    operations: [
        "operation"
    ],
    sfs: [
        "sfs"
    ],
    communications: [
        "communications"
    ],
    legal: [
        "legal"
    ],
    mondayFoundation: [
        "socialimpact",
        "monday.com foundation"
    ],
    payments: [
        "payments"
    ],
    gtm: [
        "gtm"
    ],
    customertechandai: [
        "tech & ai",
        "customer tech & ai"
    ],
    strategyandoperations: [
        "cco strategy & operations"
    ],
    customerexperience: [
        "support"
    ],
    services: [
        "delivery & solutions"
    ],
    informationtechnologyanddata: [
        "information technology",
        "business verticals",
        "shared services"
    ]
};
export const getLocationIDFromPosition = (posObj)=>{
    var _posObj_location;
    if (!(posObj === null || posObj === void 0 ? void 0 : (_posObj_location = posObj.location) === null || _posObj_location === void 0 ? void 0 : _posObj_location.name)) {
        return null;
    }
    return getLocationID(posObj.location.name);
};
const getLocationID = (locationName)=>{
    if (!locationName) return null;
    // NFD decomposition splits characters like "ü" into "u" + combining diacritic, then we strip the diacritics
    // This ensures locations like "Zürich" match the pattern "zurich"
    const normalizedLocation = locationName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
    for (const [locationId, patterns] of Object.entries(LOCATIONS)){
        if (patterns.some((pattern)=>normalizedLocation.includes(pattern))) {
            return locationId;
        }
    }
    Sentry.captureException(new Error(`Unrecognized location in position data: "${locationName}"`), {
        level: "error",
        extra: {
            locationName,
            normalizedLocation,
            availableLocationIds: Object.keys(LOCATIONS)
        }
    });
    return null;
};
// Ashby occasionally returns names with trailing whitespace (e.g. "CEO Office "). Trim so
// the exact-name lookup against careers-config display names is not whitespace-sensitive.
const getDeptIdFromName = (deptName)=>{
    const trimmed = (deptName || "").trim();
    if (!trimmed) return undefined;
    const deptInfo = careersConfig.departments.find((d)=>d.name === trimmed);
    return deptInfo === null || deptInfo === void 0 ? void 0 : deptInfo.id;
};
const getDeptID = (departmentName)=>{
    const configMatch = getDeptIdFromName(departmentName);
    if (configMatch) return configMatch;
    if (!departmentName) return null;
    const normalizedName = departmentName.toLowerCase().trim();
    if (normalizedName.includes("unlisted")) return null;
    if (DEPARTMENT_ALIASES[normalizedName]) return DEPARTMENT_ALIASES[normalizedName];
    for (const [deptId, patterns] of Object.entries(DEPARTMENTS)){
        if (patterns.some((pattern)=>normalizedName.includes(pattern))) {
            return deptId;
        }
    }
    Sentry.captureException(new Error(`Unrecognized department in position data: "${departmentName}"`), {
        level: "error",
        extra: {
            departmentName,
            normalizedName,
            availableDepartmentIds: Object.keys(DEPARTMENTS)
        }
    });
    return null;
};
export const getDeptIDFromPosition = (posObj)=>getDeptID(posObj === null || posObj === void 0 ? void 0 : posObj.department);
export const sortPositionsByName = (positions = [])=>positions.slice().sort((a, b)=>a.name.localeCompare(b.name));
export const reorderPositions = (positions = [], cities = [])=>{
    let reorderedPositions = positions.slice();
    cities === null || cities === void 0 ? void 0 : cities.forEach((city, index)=>{
        var _reorderedPositions_;
        const excludeUID = index === 1 ? (_reorderedPositions_ = reorderedPositions[0]) === null || _reorderedPositions_ === void 0 ? void 0 : _reorderedPositions_.uid : null;
        const positionIndex = findRandomPositionIndex(reorderedPositions, city, excludeUID);
        if (positionIndex > -1) reorderedPositions = moveElementInArray(reorderedPositions, positionIndex, index);
    });
    return reorderedPositions;
};
const findRandomPositionIndex = (positions = [], city, excludeUID = null)=>{
    const matches = positions.filter((position)=>{
        var _position_location_city, _position_location;
        return position.uid !== excludeUID && ((_position_location = position.location) === null || _position_location === void 0 ? void 0 : (_position_location_city = _position_location.city) === null || _position_location_city === void 0 ? void 0 : _position_location_city.toLowerCase().includes(city));
    });
    return matches.length ? positions.indexOf(matches[Math.floor(Math.random() * matches.length)]) : -1;
};
const moveElementInArray = (array, fromIndex, toIndex)=>{
    const newArray = array.slice();
    const [movedElement] = newArray.splice(fromIndex, 1);
    newArray.splice(toIndex, 0, movedElement);
    return newArray;
};
const getPaginationRange = (currentPage, totalPages, delta)=>{
    const left = currentPage - delta;
    const right = currentPage + delta + 1;
    const range = [];
    for(let i = 1; i <= totalPages; i++){
        if (i === 1 || i === totalPages || i >= left && i < right) {
            range.push(i);
        }
    }
    return range;
};
const addDotsToRange = (range)=>{
    const rangeWithDots = [];
    let lastPage;
    for (const page of range){
        if (lastPage) {
            if (page - lastPage === 2) {
                rangeWithDots.push(lastPage + 1);
            } else if (page - lastPage !== 1) {
                rangeWithDots.push("...");
            }
        }
        rangeWithDots.push(page);
        lastPage = page;
    }
    return rangeWithDots;
};
export const getPaginationArray = (currentPage, totalPages)=>{
    // const delta = isMobile() ? 1 : 2;
    const range = getPaginationRange(currentPage, totalPages, 2);
    return addDotsToRange(range);
};
const filterByDepartmentAndLocation = (pos, selectedDept, selectedLocation, dept, location)=>{
    // Case-insensitive department comparison
    const deptMatch = selectedDept === null || (dept === null || dept === void 0 ? void 0 : dept.id) && selectedDept.toLowerCase() === dept.id.toLowerCase();
    // Case-insensitive location comparison
    const locationMatch = selectedLocation === null || (location === null || location === void 0 ? void 0 : location.id) && selectedLocation.toLowerCase() === location.id.toLowerCase();
    return deptMatch && locationMatch;
};
const filterBySearchTerm = (pos, term, deptName, locationName, searchTermTokens)=>{
    var _pos_details;
    if (searchTermTokens.length === 0) return true;
    const positionDetails = ((_pos_details = pos.details) === null || _pos_details === void 0 ? void 0 : _pos_details.map((elem)=>elem.value).join(" ")) || "";
    const searchString = `${pos.name}${deptName}${locationName}${positionDetails}`.toLowerCase();
    if (searchString.includes(term)) {
        if (pos.name.toLowerCase().includes(term)) {
            pos.displayOrder = 1;
        } else if (deptName.toLowerCase().includes(term)) {
            pos.displayOrder = 2;
        } else {
            pos.displayOrder = 99;
        }
        return true;
    }
    return false;
};
export const getLocationInfoFromPosition = (posObj)=>{
    const locID = getLocationIDFromPosition(posObj);
    if (!locID) {
        Sentry.captureMessage("Position has invalid or missing location data", {
            level: "warning",
            extra: {
                positionName: posObj === null || posObj === void 0 ? void 0 : posObj.name,
                positionUid: posObj === null || posObj === void 0 ? void 0 : posObj.uid,
                locationData: posObj === null || posObj === void 0 ? void 0 : posObj.location
            }
        });
        return;
    }
    return careersConfig.locations.find((loc)=>loc.id === locID);
};
export const getDeptInfo = (posObj)=>{
    const deptID = getDeptIDFromPosition(posObj);
    if (!deptID) return;
    return careersConfig.departments.find((department)=>(department === null || department === void 0 ? void 0 : department.id) === deptID);
};
export const filterPositions = (positions, searchTerm = "", selectedDept, selectedLocation)=>{
    const term = searchTerm.toLowerCase();
    const searchTermTokens = searchTerm.trim().length === 0 ? [] : searchTerm.trim().split(" ");
    if (!positions) return [];
    try {
        const filteredData = positions.filter((position)=>{
            var _position_department;
            if (((_position_department = position.department) === null || _position_department === void 0 ? void 0 : _position_department.toLowerCase()) === "unlisted") {
                return false;
            }
            const dept = getDeptInfo(position);
            const deptName = (dept === null || dept === void 0 ? void 0 : dept.id) || "";
            const location = getLocationInfoFromPosition(position);
            const locationName = (location === null || location === void 0 ? void 0 : location.name) || "";
            const isPositionInSelectedDeptAndLocation = filterByDepartmentAndLocation(position, selectedDept, selectedLocation, dept, location);
            const doesPositionMatchSearchTerm = filterBySearchTerm(position, term, deptName, locationName, searchTermTokens);
            return isPositionInSelectedDeptAndLocation && doesPositionMatchSearchTerm;
        });
        const hasAnyFiltersOrSearch = selectedDept || selectedLocation || searchTerm && searchTerm.trim() !== "";
        if (hasAnyFiltersOrSearch) {
            filteredData.sort((a, b)=>a.displayOrder > b.displayOrder ? 1 : -1);
        }
        return filteredData;
    } catch (error) {
        return [];
    }
};
